var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infoList"},[_c('span',{staticClass:"infoListLeft"},[_vm._v(_vm._s(_vm.left))]),(_vm.right)?_c('span',{staticClass:"infoListRight"},[_vm._v(_vm._s(_vm.right))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }